export default __webpack_public_path__ + "static/media/s1_male.2e18258e.wav";